module.exports = __webpack_public_path__ + "img/content-1.889b7ddd.png";